import { Dictionary } from '@/core/lib/dict';
import { ApprovalStatus, Option } from '@/core/types/submission-artwork';

export const getOptions = (dictionary: Dictionary) => ({
  STATUS_OPTIONS_USER: [
    { value: 'active', label: dictionary.ui.status.active },
    { value: 'deactive', label: dictionary.ui.status.deactive },
  ],

  GENDER_OPTIONS: [
    { value: 'male', label: dictionary.forms.male },
    { value: 'female', label: dictionary.forms.female },
  ],

  LEVEL_OPTIONS: [
    { value: 'gold', label: dictionary.ui.level.gold },
    { value: 'silver', label: dictionary.ui.level.silver },
    { value: 'bronze', label: dictionary.ui.level.bronze },
  ],

  STATUS_OPTIONS_PAGE: [
    { value: 'draft', label: 'پیش‌نویس' },
    { value: 'publish', label: 'منتشر شده' },
    { value: 'pending', label: 'در انتظار بررسی' },
    { value: 'trash', label: 'زباله‌دان' },
    { value: 'reject', label: 'رد شده' },
  ],
  STATUS_OPTIONS_PAGE_CATEGORY: [
    { value: 'publish', label: 'منتشر شده' },
    { value: 'pending', label: 'در انتظار بررسی' },
  ],

  PAYMENT_METHOD: [
    { value: 'cheque', label: dictionary.ui.orders.cheque },
    { value: 'cash', label: dictionary.ui.orders.cash },
    { value: 'card', label: dictionary.ui.orders.card },
  ],

  STATUS_OPTIONS_PAYMENT: [
    { value: 'failed', label: dictionary.ui.orders.status.failed },
    { value: 'pending', label: dictionary.ui.orders.status.pending },
    { value: 'completed', label: dictionary.ui.orders.status.completed },
    { value: 'refunded', label: dictionary.ui.orders.status.refunded },
  ],

  APPROVAL_STATUS_OPTIONS: [
    { value: 'pending', label: 'در انتظار بررسی' },
    { value: 'approved', label: 'تایید شده' },
    { value: 'rejected', label: 'رد شده' },
  ] as Option<ApprovalStatus>[],

  FORMAT_OPTIONS: [
    {
      value: 'post_list_text_1',
      label: dictionary.ui.submissionFormats.postListText,
    },
    { value: 'gallery', label: dictionary.ui.form.galleries },
  ],

  TYPE_OPTIONS_GRID_ITEMS: [
    { value: 'text', label: dictionary.forms.text },
    { value: 'image', label: dictionary.forms.image },
  ],

  SORT_OPTIONS: [
    { label: dictionary.ui.product.sortNewest, value: '' },
    { label: dictionary.ui.product.sortOldest, value: 'oldest' },
    { label: dictionary.ui.product.sortPopular, value: 'popular' },
    { label: dictionary.ui.product.sortCheapest, value: 'cheapest' },
    { label: dictionary.ui.product.sortExpensive, value: 'expensive' },
  ] as Array<{
    label: string;
    value: '' | 'popular' | 'cheapest' | 'expensive' | 'oldest';
  }>,
});
